import React from "react";
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { 
    Box,
    Button,
    Grid,
    CircularProgress,
    Typography
} from "@mui/material";
import { verifyPaymentCallback } from "../../Redux/Reducers/PaymentCallback";

const MAX_RETRIES = 5;

const PaymentCallbackPage = () => {
    const dispatch = useDispatch();
    const [ searchParams ] = useSearchParams();
    const navigate =  useNavigate();

    const [ status, setStatus ] = useState("LOADING");
    const [ message, setMessage ] = useState("Verifying Payment....");
    const [retryCount, setRetryCount] = useState(0);
    
    const sendMessageToApp = (payload) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(payload));
        } else if (window.flutter_inappwebview) {
            window.flutter_inappwebview.callHandler('paymentHandler', payload);
        } else {
            console.log("No mobile bridge detected");
        }
    };

    useEffect(() => {
        const verifyPayment = async () => {
            const transactionId = searchParams.get("tx");
            const userId = searchParams.get("customerId");
            const status = searchParams.get("status");
            const id = searchParams.get("id");
            
            if (!transactionId) {
                setStatus("ERROR");
                setMessage("Invalid payment reference");
                return;
            }

            try {
                // Await dispatch result
                const res = await dispatch(
                    verifyPaymentCallback({transactionId, userId})
                ).unwrap();

                const statusVal = res.data.data.status || "ERROR";

                // Expecting response like { status: "SUCCESS" | "FAILED" | "PENDING" }
                if (statusVal === "PENDING") {
                    setTimeout(() => verifyPayment(), 3000);
                }
                
                if (statusVal === "SUCCESS") {
                    setStatus(statusVal);
                    setMessage("Payment successful");

                    sendMessageToApp({
                        type: "PAYMENT_STATUS",
                        status: "SUCCESS",
                        transactionId,
                    });
                } else if (statusVal === "FAILED") {
                    setStatus(statusVal);
                    setMessage("Payment failed. Try again.");

                    sendMessageToApp({
                        type: "PAYMENT_STATUS",
                        status: "FAILED",
                        transactionId,
                    });
                } else if (statusVal === "PENDING") {
                    if (retryCount < MAX_RETRIES) {
                        setRetryCount((prev) => prev + 1);
                        setStatus(statusVal);
                        setMessage("Processing payment, please wait...");
                        setTimeout(verifyPayment, 3000);
                    }else{
                        setStatus("TIMEOUT");
                        setMessage("Payment taking too long. Please check later.");
                    }
                }
            } catch (error) {
                //setStatus("ERROR");
                // setMessage("Something went wrong");
            }
        };

        verifyPayment();
    }, [searchParams, navigate, dispatch]);


    return (
        <Box sx={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15px' }}>
            <Box sx={{ p: "15px", textAlign: "center", backgroundColor:"rgba(255, 255, 255, 0.1)", border: "1px solid rgba(230, 210, 249, 0.2)", color: '#fff', borderRadius: '10px', maxWidth: '450px', width: "100%", minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
        
                {/* {status === "LOADING" && <CircularProgress />} */}
                {status === "LOADING" && (
                    <>
                        <CircularProgress />
                        <Typography sx={{ mt: 2 }}>Verifying payment...</Typography>
                    </>
                )}

                {/* <Typography variant="h5" sx={{ mt: 2 }}>
                    {status === "SUCCESS" && "Payment Successful"}
                    {status === "FAILED" && "Payment Failed"}
                    {status === "PENDING" && "Payment Pending"}
                    {status === "ERROR" && "Error"}
                </Typography>

                <Typography sx={{ mt: 1, color: "#000000" }}>
                    {message}
                </Typography> */}

            </Box>
        </Box>
    );

};

export default PaymentCallbackPage;
